const primaryMain = '#0F5640';
const primaryMainOpacity = 'rgba(15,86,64, 0.5)';
const secondaryMain = '#1BA72E';
const secondaryMainOpacity = 'rgb(27,167,46, 0.5)';
const secondaryLight = '#47a654';
const tertiaryMain = '#0F5640';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
